import { useResourcesStore } from '@/stores/resources'
import { createFileRoute } from '@tanstack/react-router'
import { DirectoryView } from '@/components/views/DirectoryView'

export const Route = createFileRoute('/_auth/directory')({
  beforeLoad: () => ({ title: 'Directory' }),
  component: DirectoryView,
  loader: () => useResourcesStore.getState().actions.fetchResources(),
})
